<template>
  <div class="">
    <div class="seth-set bg-primary px-6 py-10">
      <p
        @click="handleBack"
        class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
      >
        <feather-icon class="flex" icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
        Go Back
      </p>
      <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
        Payment Method
      </h2>
    </div>
    <div class="p-8 menucontrol-scroll fixed-top">
      <Connect />
      <Setup />
    </div>
  </div>
</template>
<script>
import Connect from "./components/Connect.vue";
import Setup from "./components/Setup.vue";
export default {
  components: {
    Connect,
    Setup,
  },
  methods: {},
};
</script>
